import { render, staticRenderFns } from "./ViewAllOrders.vue?vue&type=template&id=27dae8a0"
import script from "./ViewAllOrders.vue?vue&type=script&lang=js"
export * from "./ViewAllOrders.vue?vue&type=script&lang=js"
import style0 from "./ViewAllOrders.vue?vue&type=style&index=0&id=27dae8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports